import type { Match } from '@uefadigital/panenka';
import { MatchStatus, MatchUnitSize } from '@uefadigital/panenka';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import type { HpMatchFinalOptions } from '../../app';
import Countdown from '../Countdown';
import Winner from '../Winner';

import { useWindowSize } from '@hooks/useWindowSize';
import MatchUnit from '@shared/MatchUnit';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const Final = ({ options, match }: { options: HpMatchFinalOptions; match: Match }) => {
  const t = useTranslateFn();
  const { isMobile, isDesktopExtraLarge } = useWindowSize();

  const logoStyle = useMemo(() => (options?.showLogoTitle ? styles.logo : styles.title), [options?.showLogoTitle]);
  const muSize = useMemo(
    () => (isMobile || isDesktopExtraLarge ? MatchUnitSize.XL : MatchUnitSize.M),
    [isMobile, isDesktopExtraLarge],
  );
  const cDate = useMemo(() => {
    return options.countdownDate ?? match?.kickOffTime?.dateTime;
  }, [options.countdownDate, match?.kickOffTime?.dateTime]);

  const customImage = useMemo(() => {
    return options.enableCustomSponsorImage && match?.status === MatchStatus.UPCOMING;
  }, [options.enableCustomSponsorImage, match?.status]);

  if (!match) return null;

  return (
    <div
      className={clsx({
        ['pk-col pk-col--span-12 pk-d--flex pk-flex--wrap']: true,
        ['pk-align-items-sm--center']: !customImage,
        ['custom-image pk-align-items--stretch']: customImage,
      })}
    >
      {match.status === MatchStatus.FINISHED ? (
        <Winner match={match} confettiUrl={options.confettiUrl} />
      ) : (
        <div className={clsx({ [styles.countdown]: true })}>
          <div className={logoStyle}>{!options.showLogoTitle && t(options.countdownLabel ?? 'countdown_to_final')}</div>
          {!!cDate && (
            <Countdown
              countdownDate={cDate}
              sponsorTag={options?.sponsorTag}
              customSponsorImage={options?.enableCustomSponsorImage}
              countdownLabel={options?.countdownLabel}
            />
          )}
        </div>
      )}
      <div className={styles.match}>
        <MatchUnit options={options} match={match} size={muSize} />
      </div>
    </div>
  );
};

export default memo(Final);
